import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { IGetAllServiceProps } from "@api/types/globalService.types";
import { useQuery } from "@tanstack/react-query";
import {
  getAllManufacturerAPI,
  getSingleManufacturerAPI,
} from "./manufacturer.api";
import useGlobalDebounceHandler from "../useGlobalDebounceHandler";
import { useState } from "react";

type IManufacturerServiceProps = Omit<IGetAllServiceProps, "stage_id">;

const useAllManufacturerService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
  cacheKeys = [],
  filters,
}: IManufacturerServiceProps) => {
  const [searchManufacturerQuery, setSearchManufacturerQuery] =
    useState<string>("");

  const { debouncedQuery } = useGlobalDebounceHandler(searchManufacturerQuery);
  const allManufacturerService = useQuery({
    queryKey: [...CACHE_KEYS.MANUFACTURER, page, per_page, ...cacheKeys],
    queryFn: () =>
      getAllManufacturerAPI({
        searchParams: {
          "filter[name]": debouncedQuery,
          page,
          per_page,
          ...filters,
        },
      }),
    enabled: enableQuery,
  });

  return {
    states: { searchManufacturerQuery, setSearchManufacturerQuery },
    services: { allManufacturerService },
  };
};

const useSingleManufacturerService = ({
  singleManufacturerId,
  enableQuery = true,
}: {
  singleManufacturerId: string;
  enableQuery?: boolean;
}) => {
  return useQuery({
    queryKey: [...CACHE_KEYS.MANUFACTURER, singleManufacturerId],
    queryFn: () => getSingleManufacturerAPI(singleManufacturerId),
    enabled: !!singleManufacturerId && enableQuery,
  });
};

export { useAllManufacturerService, useSingleManufacturerService };
